import styled from '@emotion/styled';
import Typography from '@material-ui/core/Typography';

import { colors } from '../../constants.js/colors';
import { Button, FormLabel, OutlinedInput, Link } from '@material-ui/core';

export const AuthFormWrapper = styled.div`
    width: 100%;
    animation: fadein 0.5s;
    position: relative;
    background-color: ${colors.neutral[600]};
`;

export const AuthFormAside = styled.div`
    height: calc(100vh - 24px);
    width: 100%;
    overflow: hidden;
    background-size: cover;
    background-position: center;
    border-radius: 16px;
`;

export const AuthFormMainContent = styled.div`
    // position: absolute;
    // left: 0;
    // right: 0;
    // top: 0;
    // bottom: 0;
    // z-index: 2;
    // padding: 12px;
    width: 100%;
`;

export const AuthFormHeader = styled.div`
  display: flex;
  align-items: center;
  column-gap 10px;
  height: 64px;
  width: 100%;
  margin-top: 20px;
  padding: 8px;
  >.container-flags {
    display: flex;
    column-gap 10px;
  }
`;

export const AuthFormContainer = styled.div`
    padding: 24px 0;
    h1 {
        color: ${colors.white};
    }
`;

export const MobileContent = styled.div`
    width: 100%;
    height: 100%;
    > img {
        margin: 0 auto;
        display: block;
        text-align: center;
    }
    h1 {
        font-style: normal;
        font-weight: normal;
        font-size: 22px;
        line-height: 24px;
        text-align: center;
        color: ${colors.white};
    }
    button {
        width: 100%;
    }
    display: none;
    @media screen and (max-width: 414px) {
        display: block;
    }
`;

export const MBHeader = styled.div`
    height: 320px;
    left: 0px;
    ${(props) => (props.isLogin ? 'background: #CAD7CA' : 'background: #C8D7E5')};
    margin-bottom: -15rem;
    border-bottom-left-radius: 30px;
    border-bottom-right-radius: 30px;
    > img {
        position: absolute;
        top: 66px;
        left: 0;
        right: 0;
        margin: auto;
    }
`;

export const ContentMB = styled.div`
    margin-top: 8rem;
    padding: 2rem;
`;

export const AuthFormContent = styled.div`
    overflow-y: auto;
    padding: 75px 160px;
    flex: 1;
`;

export const AuthFormSubtitle = styled(Typography)`
    color: ${colors.white};
    overflow-y: auto;
    padding-top: 10px;
    padding-bottom: 36px;
`;

export const AuthFormInput = styled(OutlinedInput)`
    background-color: ${colors.white};
`;

export const AuthFormLabel = styled(FormLabel)`
    color: ${colors.white};
`;

export const AuthFormButton = styled(Button)`
    background-color: ${colors.primary.main};
    border-radius: 100px;
`;

export const AuthFooterContainer = styled.div`
    position: relative;
    background: ${colors.neutral[500]};
    color: ${colors.white};
    padding: 80px 0;
    text-align: center;
    border-radius: 36px 36px 0 0;

    a {
        color: ${colors.white};
        text-decoration: none;
    }

    img {
        height: 36px;
    }
`;

export const AuthFooterSocialsContainer = styled(Link)`
    padding: 10px;
    border-radius: 10px;
    background-color: ${colors.neutral[400]};
    display: flex;
`;
